export default __webpack_public_path__ + "static/media/cover-image.8118371b.png";